import Apuracao from './ApuracaoPage';

export default Apuracao;
